import {Sticky} from '@wr/ui-patterns';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getGenericError, getGenericErrorType, getTranslations} from '../../../utils/selectors';
import {GENERIC_ERROR_TYPES} from '../../../consts';

const GenericErrorComponent = ({show, type, translations}) => {
    const getMessageText = () => {
        if (type === GENERIC_ERROR_TYPES.session) {
            return translations.common.sessionExpiredError;
        }
        return translations.common.genericError;
    };

    return (
        show ? (
            <Sticky topSticky className="sticky-generic-error">
                <div className="sticky-generic-error">
                    <div className="generic-error-notification">
                        <span className="icon-alert" />
                        <p>{getMessageText()}</p>
                    </div>
                </div>
            </Sticky>
        ) : null
    );
};

GenericErrorComponent.propTypes = {
    show: PropTypes.bool,
    translations: PropTypes.shape({
        common: PropTypes.shape({
            genericError: PropTypes.string.isRequired,
            sessionExpiredError: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    type: PropTypes.string
};

GenericErrorComponent.defaultProps = {
    show: false,
    type: GENERIC_ERROR_TYPES.standard
};

const mapStateToProps = state => ({
    show: !!getGenericError(state),
    type: getGenericErrorType(state),
    translations: getTranslations(state)
});

export const ConnectedGenericErrorNotification = connect(
    mapStateToProps,
    null
)(GenericErrorComponent);

export default withRouter(ConnectedGenericErrorNotification);
